import { APP_MANAGED_ROUTES } from "common/app-managed-routes";
import { VENDOR_SSO_LINKS } from "common/vendor-sso-links";

// Production keeps the SSO link until the native My Profile launches.
export const getMyProfileLink = (): string =>
  import.meta.env.VITE_APP_ENV === "production"
    ? VENDOR_SSO_LINKS.MY_PROFILE
    : APP_MANAGED_ROUTES.MY_PROFILE;
